import React from "react";
import cn from "classnames";

import {
    StyledEditorBar,
    StyledCenter,
    StyledFlexLeft,
    StyledFlexRight,
    StyledChanger,
    StyledChangerPopup,
    CenterTooltip,
} from "./styles";
import {
    IEditorBarProps,
    IFlexLeftProps,
    IFlexRightProps,
    ICenterProps,
    IChangerProps,
    IChangerPopupProps,
} from "./interfaces";
export * from "./styles";


const EditorBar = ({ children }: IEditorBarProps) => <StyledEditorBar>{children}</StyledEditorBar>;

export default EditorBar;

export const FlexLeft = ({ children, flexDirection }: IFlexLeftProps) => (
    <StyledFlexLeft flexDirection={flexDirection}>{children}</StyledFlexLeft>
);

export const FlexRight = ({ children }: IFlexRightProps) => <StyledFlexRight>{children}</StyledFlexRight>;

export const Center = ({ onClick, children, disabled, className, loading, tooltip }: ICenterProps) => (
    <StyledCenter
        disabled={disabled}
        onClick={onClick}
        className={cn("button--pretty", "button", className, loading && "button--loading")}
    >
        {tooltip && (
            <CenterTooltip>{tooltip}</CenterTooltip>
        )}
        {children}
    </StyledCenter>
);

export const Changer = ({ children, active, disabled }: IChangerProps) => (
    <StyledChanger className={cn(active && "Active", disabled && "Disabled")}>{children}</StyledChanger>
);

export const ChangerPopup = ({ children, setRef, onRight, dark }: IChangerPopupProps) => (
    <StyledChangerPopup
        className={cn(onRight && "OnRight", dark && "Dark")}
        ref={typeof setRef === "object" ? setRef : (r => setRef(r!))}
    >
        {children}
    </StyledChangerPopup>
);

export const Icon = ({ children }: IEditorBarProps) => <div>{children}</div>;

